export default __webpack_public_path__ + "static/media/GalanoGrotesque-SemiBold.77c749fe.woff2";